import { render } from "./Cv.vue?vue&type=template&id=6be25f1d&ts=true"
import script from "./Cv.vue?vue&type=script&lang=ts"
export * from "./Cv.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\dev\\laragon\\www\\test-interactiv\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__